var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChevronDownGradient(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 6.66663L8.4714 10.1952C8.21106 10.4556 7.78894 10.4556 7.5286 10.1952L4 6.66663",
    stroke: "url(#paint0_linear_11759_4157)",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_11759_4157",
    x1: -0.55,
    y1: 4.59523,
    x2: 4.05269,
    y2: 14.0499,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#299FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0202A8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronDownGradient);
export default __webpack_public_path__ + "static/media/chevron-down-gradient.fd992533096f8100249ae23e2b30ee0c.svg";
export { ForwardRef as ReactComponent };